<template>
  <div class="divIndexRequests">
    <loading :showLoading="load" />
    <grid
      v-if="!load"
      class="grid"
      :title="$t('grid.Title')"
      :headers="headers"
      controller
      readAll="Request/GetRequests"
      :disableEdit="true"
      :disableDelete="true"
      :ExportExcel="true"
      :ExportExcelLabel="$t('grid.ExportExcel')"
      :ShowMenu="true"
      createComponentRoute="ConfigEdit"
      :refresh="this.$store.getters.GET_reloadPage"
      :showFooter="false"
      :canExpand="false"
      :externalFilters="this.$store.getters.GET_elementToSearchOfGridMenu"
      searchFields="ShipmentNumber,Sender,Recipient"
      :exportHeaders="exportHeaders"
      :AddItem="$t('ContextMenu.AddRequest')"
      :DefaultSorting="true"
      EditRoute="RequestEdit"
      :enableDblClick="true"
      defaultColSorting="dateCreated"
      :deafaultDescSorting="true"
    >
    </grid>
  </div>
</template>
<script>
import loading from "../components/loadingComponent.vue";
import grid from "../components/gridComponent.vue";
import { Trans } from "@/plugins/Translation";
import IMApi from "../api/IM/IMApi.js";

export default {
  components: {
    grid,
    loading,
  },

  data() {
    return {
      headers: [
        {
          text: Trans.i18n.t("grid.Columns.Title"),
          value: "title",
          width: "20%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Username"),
          value: "username",
          width: "18%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Status"),
          value: "status",
          width: "10%",
        },
        {
          text: Trans.i18n.t("grid.Columns.ShipmentNumber"),
          value: "shipmentNumber",
          width: "10%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Sender"),
          value: "sender",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.Recipient"),
          value: "recipient",
          width: "15%",
        },
        {
          text: Trans.i18n.t("grid.Columns.DateCreated"),
          value: "dateCreated",
          width: "12%",
        },
        { text: "", value: "edit", width: "100" },
      ],
      exportHeaders: [ ],
      filters: {},
      localStorageItemGridId: "app_savedSearchParamsGrid",
      load: false,
    };
  },

  watch: {
    '$store.getters.GET_languageChanged': function() {
      this.updateExportHeader();
    }

  },

  async created() {
    let user = this.$GAUserAuth.user;
    this.load = true;

    // only ad user can be access
    let aduserInfo_res = await IMApi.GetADUserInformationByUsername(
      user.username
    );
    // console.log("aduserInfo_res.data", aduserInfo_res.data);
    if (!aduserInfo_res.data) {
      this.$router.push({ name: "unauthorized" });
    }

    // console.log("home user", user);

    // this.filters = JSON.parse(
    //   localStorage.getItem(this.localStorageItemGridId)
    // );

    // var lolSFilter = JSON.parse(localStorage.getItem("FullTextWithLike"));
    //   if(lolSFilter)
    //     localStorage.removeItem("FullTextWithLike")

    this.filters = [
      { Field: "Username", FilterType: 7, Filtervalue: user.username },
    ];

    // only admins can view all the request
    if (this.$GAUserAuth.isAdmin() || this.$GAUserAuth.isSupervisor()) {
      this.filters = [];
      // console.log("admin user or Supervisor user");
    } else {
      // console.log("base user");
    }

    this.filters.push({ Field: "Archived", FilterType: 7, Filtervalue: false });

    //console.log("home filters", this.filters)
    this.$store.commit("SET_elementToSearchOfGridMenu", this.filters);

    this.$store.commit("SET_reloadPage", !this.$store.getters.GET_reloadPage);
    this.load = false;
    this.updateExportHeader();
  },
  methods: {
    updateExportHeader() {
      this.exportHeaders = [
        { text: Trans.i18n.t("grid.Columns.Id"), value: "id" },
        { text: Trans.i18n.t("grid.Columns.Username"), value: "username" },
        { text: Trans.i18n.t("grid.Columns.BranchId"), value: "branchId" },
        { text: Trans.i18n.t("grid.Columns.BUId"), value: "buId" },
        { text: Trans.i18n.t("grid.Columns.Title"), value: "title" },
        { text: Trans.i18n.t("grid.Columns.Status"), value: "status" },
        {
          text: Trans.i18n.t("grid.Columns.DateCreated"),
          value: "dateCreated",
        },
        {
          text: Trans.i18n.t("grid.Columns.DateTransport"),
          value: "dateTransport",
        },        
        { text: Trans.i18n.t("grid.Columns.Warranty"), value: "warrantyDescription" },
        {
          text: Trans.i18n.t("grid.Columns.ShipmentNumber"),
          value: "shipmentNumber",
        },
        { text: Trans.i18n.t("grid.Columns.Sender"), value: "sender" },
        { text: Trans.i18n.t("grid.Columns.Recipient"), value: "recipient" },
        { text: Trans.i18n.t("grid.Columns.CarrierCodeList"), value: "carriersCodeList" },
        { text: Trans.i18n.t("grid.Columns.VehiclesTypesList"), value: "vehiclesTypesList" },
        { text: Trans.i18n.t("grid.Columns.GrossWeight"), value: "grossWeight" },
        { text: Trans.i18n.t("grid.Columns.Value"), value: "value" },
        { text: Trans.i18n.t("grid.Columns.ValueGuaranteed"), value: "valueGuaranteed" },
        { text: Trans.i18n.t("grid.Columns.Currency"), value: "currency" },        
      ];

      if (Trans.currentLanguage == "it") {
          this.exportHeaders.splice(12, 0, { text: Trans.i18n.t("grid.Columns.CategoryDescription"), value: "categoryDescription" });        
      }
      else {
          this.exportHeaders.splice(12, 0, { text: Trans.i18n.t("grid.Columns.CategoryDescription"), value: "categoryDescriptionEN" });
      }
    }
}
};
</script>
